/** Pause-after-speech for fluid conversation (must match server bounds). */
export const FLUID_SILENCE_MS_DEFAULT = 2000;
export const FLUID_SILENCE_MS_MIN = 800;
export const FLUID_SILENCE_MS_MAX = 5000;

export function clampFluidSilenceMs(n: number): number {
  return Math.min(FLUID_SILENCE_MS_MAX, Math.max(FLUID_SILENCE_MS_MIN, Math.round(n)));
}

export function parseFluidSilenceMsFromApi(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value)) return clampFluidSilenceMs(value);
  if (typeof value === 'string') {
    const n = parseInt(value, 10);
    if (Number.isFinite(n)) return clampFluidSilenceMs(n);
  }
  return FLUID_SILENCE_MS_DEFAULT;
}
